<template>
    <div class="news">
        <div class="box" v-for="(value,index) in newsList" :key="index">
            <div class="left">
                <img :src="apiUrl+value.news_cover.replace(/\/download/g,'public')" alt="">
            </div>
            <div class="right">
                <p class="title">
                    <span class="text" :title="value.news_title">{{value.news_title}}</span>
                    <span class="time">{{value.publish_time}}</span>
                </p>
                <div class="detail">
                    {{value.news_abstract}}
                </div>
                <div class="button" @click="changePage(value.news_id)">查看详情</div>
            </div>
        </div>
        <div class="more" v-if="this.newsList.length<total" @click="moreNews()">
            查看更多
        </div>
    </div>
</template>
<script>

import {getNewsListApi} from "@/request/api"
export default {
    name:"news",
    data(){
        return{
            newsList:[],
            apiUrl:window.g.apiUrl,
            total:'',
            searchInfo:{
                page_size:5,
                page:1
            },
            showNum:5
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            this.getToken(getNewsListApi,this.searchInfo,res=>{
                this.newsList = res.data.data_info
                this.total=res.data.data_count
            })
        },
        changePage(id){
            this.$router.push({name:'aboutDetailNews',params:{id:id}})
        },
        moreNews(){
            this.searchInfo.page_size+=this.showNum
            this.init()
        }
    }
    
}
</script>
<style lang="stylus" scoped>
.news
    padding:30px;
    padding-top:0;
    .box
        display:flex;
        justify-content:space-between;
        padding:40px 30px 30px;
        border-bottom:1px solid #e3e3e3;
        height:235px;
        
        .left
            img
                margin-right:20px;
                width:200px;
                height:130px;
        .right
            .title
                display:flex;
                align-items:center;
                justify-content:space-between;
                .text
                    font-size:20px;
                    width:400px;
                    color:#000;
                    overflow:hidden;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    display:inline-block;
                .time
                    color:#999;
                    font-size:14px;
            .detail
                color:#7c7c7c;
                font-size:14px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                text-align:justify;
                height:65px;
                line-height:23px;
            .button
                border:1px solid #999;
                line-height:25px;
                display:inline-block;
                color:#999;
                font-size:14px;
                border-radius:15px;
                padding:0 10px;
                float:right;
                margin-top:20px;
                cursor:pointer;
                &:hover
                    color:#1890ff;
                    border-color:#1890ff;
    .more
        background:#e1dede;
        color:#999;
        text-align:center;
        line-height:40px;
        cursor:pointer;
        margin-top:-10px;
</style>